import { completeMultipartUpload } from 'http/system';

const uploadPart = async (presignedUrl, blob, partNumber) => {
  const response = await fetch(presignedUrl, {
    method: 'PUT',
    body: blob,
  });

  if (!response.ok) throw new Error(`Failed to upload part ${partNumber}`);

  const etag = response.headers.get('Etag').replace(/"/g, '');
  return { PartNumber: partNumber, ETag: etag };
};

export default async (file, s3FileName, bucket, uploadId, presignedUrls, partSize) => {
  const uploadPromises = [];
  const parts = [];
  for (let i = 0; i < presignedUrls.length; i += 1) {
    const start = i * partSize;
    const end = Math.min(file.size, start + partSize);
    const blob = file.slice(start, end);

    const partNumber = i + 1;
    const presignedUrl = presignedUrls[i].url;

    const uploadPromise = uploadPart(presignedUrl, blob, partNumber)
      .then((part) => parts.push(part));

    uploadPromises.push(uploadPromise);
  }

  await Promise.all(uploadPromises);
  await completeMultipartUpload(s3FileName, bucket, uploadId, parts);
};
